import React from "react";
import { Link } from "react-router-dom";
import SectionHeading from "../landing/SectionHeading";

/**
 * v2 Close — the real conversion section.
 * Replaces the trio of InvestorAccess + Offices + Contact at the bottom of v1.
 * Strong headline, two CTAs, then a single-row horizontal Offices strip
 * (Austin HQ + 5 coverage cities) — confident, not housekeeping.
 */
const OFFICES = [
  { city: "Austin", region: "HQ" },
  { city: "New York", region: "Coverage" },
  { city: "London", region: "Coverage" },
  { city: "Geneva", region: "Coverage" },
  { city: "Dubai", region: "Coverage" },
  { city: "Singapore", region: "Coverage" },
  { city: "Hong Kong", region: "Coverage" },
];

const CloseInvestorAccess = ({ onRequestAccess, onStrategic }) => {
  return (
    <section
      id="investor-access"
      data-testid="kr-v2-close"
      className="relative py-32 lg:py-44 border-t border-[var(--kr-line-soft)] kr-atmosphere"
      style={{ background: "var(--kr-bg-2)" }}
    >
      {/* atmospheric corner accents */}
      <div
        aria-hidden
        className="absolute -top-40 -right-32 w-[640px] h-[640px] rounded-full opacity-[0.10] blur-[120px]"
        style={{
          background:
            "radial-gradient(circle, rgba(201,169,110,0.65), transparent 70%)",
        }}
      />

      <div className="relative max-w-[1480px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16 mb-20">
          <div className="lg:col-span-7">
            <SectionHeading
              index="08"
              label="Engagement"
              title={
                <>
                  Engage with the{" "}
                  <span className="italic text-[var(--kr-gold)]">
                    partnership
                  </span>
                  .
                </>
              }
            />
            <p className="mt-8 text-[var(--kr-text-muted)] text-[17px] leading-[1.85] max-w-[58ch]">
              Kellermann Reid &amp; Co. is in a selective engagement phase with
              strategic capital partners, family offices, placement agents and
              institutional counterparties. Initiate a confidential dialogue.
            </p>
          </div>

          <div className="lg:col-span-5 lg:pl-10 flex flex-col justify-end gap-4">
            <button
              type="button"
              onClick={onRequestAccess}
              data-testid="kr-v2-close-request"
              className="kr-btn-primary"
            >
              Request Investor Access
              <span aria-hidden>→</span>
            </button>
            <button
              type="button"
              onClick={onStrategic}
              data-testid="kr-v2-close-strategic"
              className="kr-btn-ghost"
            >
              Discuss Strategic Partnership
            </button>
            <Link
              to="/contact"
              data-testid="kr-v2-close-contact"
              className="font-mono-label text-[10px] text-[var(--kr-text-muted)] hover:text-[var(--kr-gold)] transition-colors mt-2 self-start"
            >
              General Enquiry →
            </Link>
          </div>
        </div>

        {/* Offices strip — single horizontal row */}
        <div
          data-testid="kr-v2-close-offices"
          className="pt-10 border-t border-[var(--kr-line)]"
        >
          <div className="flex items-center gap-4 mb-6 flex-wrap">
            <span className="font-mono-label text-[10px] text-[var(--kr-gold)]">
              Global Footprint
            </span>
            <span className="w-10 h-px bg-[var(--kr-gold)]/60" />
            <span className="font-mono-label text-[10px] text-[var(--kr-text-muted)]">
              Texas-formed · International coverage
            </span>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-y-6 gap-x-4">
            {OFFICES.map((o) => (
              <div
                key={o.city}
                data-testid={`kr-v2-close-office-${o.city
                  .toLowerCase()
                  .replace(/\s+/g, "-")}`}
                className="border-l border-[var(--kr-line)] pl-4"
              >
                <div className="font-serif-display text-[var(--kr-text)] text-[1.35rem] leading-[1.1]">
                  {o.city}
                </div>
                <div
                  className={`font-mono-label text-[9.5px] mt-2 ${
                    o.region === "HQ"
                      ? "text-[var(--kr-gold)]"
                      : "text-[var(--kr-text-muted)]"
                  }`}
                >
                  {o.region}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CloseInvestorAccess;
